import { Card } from '@astryxdesign/core/Card';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import type { Studio } from '@/api/schemas';
import { infoIcon } from '@/components/icons';

export function InfoCards({ cards }: { cards: Studio['infoCards'] }) {
  if (cards.length === 0) return null;
  return (
    <ul className="snap-row" aria-label="О студии">
      {cards.map((c) => {
        const Icon = infoIcon(c.icon);
        return (
          <li key={c.position} className="snap-row__item snap-row__item--card">
            <Card height="100%">
              <VStack gap={2}>
                <Icon size={28} className="text-accent" aria-hidden />
                <Text weight="semibold">{c.title}</Text>
                <Text color="secondary">{c.body}</Text>
              </VStack>
            </Card>
          </li>
        );
      })}
    </ul>
  );
}
